var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogotypeRingoverCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6561_29312)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1282 23.9994C6.27614 23.9994 1.68167 20.1053 0.643747 14.4605C0.624372 14.3551 0.589355 14.1426 0.589355 14.1426L6.38804 14.1427C6.38804 14.1427 6.42617 14.27 6.44648 14.3326C7.30621 16.9823 9.64133 18.3524 12.1282 18.3524C14.6192 18.3524 16.9579 17.0064 17.8141 14.337C17.8347 14.2729 17.8732 14.1426 17.8732 14.1426L23.667 14.1426C23.667 14.1426 23.6379 14.3203 23.622 14.4085C22.6029 20.0813 17.9982 23.9994 12.1282 23.9994Z",
    fill: "url(#paint0_linear_6561_29312)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1268 0C18.2477 0 22.9929 4.22147 23.7315 10.3184C23.7474 10.4494 23.7736 10.7141 23.7736 10.7141L18.06 10.7141C18.06 10.7141 18.0353 10.5638 18.0214 10.4899C17.4159 7.27132 14.8632 5.64694 12.1268 5.64694C9.42166 5.64694 6.89605 7.23438 6.2537 10.3801C6.23136 10.4896 6.19358 10.7141 6.19358 10.7141L0.47998 10.7141C0.47998 10.7141 0.517846 10.3425 0.542271 10.1593C1.34356 4.14816 6.05922 0 12.1268 0Z",
    fill: "url(#paint1_linear_6561_29312)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6561_29312",
    x1: 0.589355,
    y1: 14.1426,
    x2: 7.71027,
    y2: 30.8147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36CDCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40E0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6561_29312",
    x1: 0.47998,
    y1: 0,
    x2: 8.61501,
    y2: 17.6864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36CDCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40E0CF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6561_29312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogotypeRingoverCircle);
export default __webpack_public_path__ + "static/media/logotype-ringover-circle.b40e3febabb62fd8dec834e3daa9d5bb.svg";
export { ForwardRef as ReactComponent };